/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import HospitalsidHospital from './HospitalsidHospital';

/**
 * The HospitalsIdBody model module.
 * @module model/HospitalsIdBody
 * @version v0.3
 */
export default class HospitalsIdBody {
  /**
   * Constructs a new <code>HospitalsIdBody</code>.
   * @alias module:model/HospitalsIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>HospitalsIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/HospitalsIdBody} obj Optional instance to populate.
   * @return {module:model/HospitalsIdBody} The populated <code>HospitalsIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new HospitalsIdBody();
      if (data.hasOwnProperty('hospital'))
        obj.hospital = HospitalsidHospital.constructFromObject(data['hospital']);
    }
    return obj;
  }
}

/**
 * @member {module:model/HospitalsidHospital} hospital
 */
HospitalsIdBody.prototype.hospital = undefined;

